import React from 'react'

export const MainLayouts = {
    layout1: React.lazy(() => import('./Layout1/Layout1'))
}
